const BackEndURLs = {
    Development: {
        baseUrl: 'https://dev.api.pi.aro.homes',
        //        dataGrid: 'https://dev.query.pi.aro.homes',
        dataGrid: 'https://prod.query.pi.aro.homes',
    },
    Staging: {
        baseUrl: 'https://staging.api.pi.aro.homes',
        dataGrid: 'https://staging.query.pi.aro.homes',
    },
    Production: {
        baseUrl: 'https://prod.api.pi.aro.homes',
        dataGrid: 'https://prod.query.pi.aro.homes',
    },
};

const Environment = 'Production';

export function GET_ENVIRONMENT() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return 'Development';
    }
    return Environment;
}

export const getBaseURL = () => {
    let env = GET_ENVIRONMENT();
    return `${BackEndURLs[env].baseUrl}`;
};

export const getDataGridURL = () => {
    let env = GET_ENVIRONMENT();
    return `${BackEndURLs[env].dataGrid}`;
};
